import React, { useState, useEffect } from 'react'
import {
  Form,
  Pagination,
  Button,
  Modal,
  Container,
  Row,
  Col,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { FaSyncAlt } from 'react-icons/fa'

import { PencilSquare, Book } from 'react-bootstrap-icons'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import EditCourseModal from './EditCourseModal'
import Cookies from 'js-cookie'

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
const DataTable = () => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const initialData = []

  const [data, setData] = useState(initialData)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedCourse, setSelectedCourse] = useState(null)
  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState([])
  const [allCourses, setAllCourses] = useState([])
  const [loading, setLoading] = useState(false)
  const [isAcknowledged, setIsAcknowledged] = useState(false)

  useEffect(() => {
    const instituteId = Cookies.get('institute_id')
    if (!instituteId) {
      setData([])
      setAllCourses([])
      toast.error('No Institute ID found. Cannot fetch courses.')
      return
    }

    ApiEndpoints.getAllCourses()
      .then((response) => {
        const allCourses = response.data.data || []
        setData(allCourses)
        setAllCourses(allCourses)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [loading])

  useEffect(() => {
    const userLogged = Cookies.get('user')
    console.log('userLogged', userLogged)
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
         setUserRole(JSON.parse(userLogged))
        console.log('User:', JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  const [newCourse, setNewCourse] = useState({
    course_name: '',
    duration: '',
    fee: '',
    description: '',
  })

  const [selectedData, setSelectedData] = useState({})

  const fetchFilteredData = (selectedValues) => {
    const { course } = selectedValues
    let updatedData = allCourses
    console.log('updatedData', updatedData)
    if (course) {
      updatedData = updatedData.filter(
        (item) => item.id?.toString() === course.toString(),
      )
    }

    setData(updatedData)
  }

  useEffect(() => {
    fetchFilteredData(selectedData)
  }, [])
  // Filter Data Based on Search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewCourse((prev) => ({ ...prev, [name]: value }))
  }

  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      const institueId = Cookies.get('institute_id')
      console.log('INSTITUTE ID', institueId)
      const response = await ApiEndpoints.addCourse(newCourse, institueId)
      console.log('Sending Response: ', response)

      setNewCourse(response)
      setNewCourse({ course_name: '', duration: '', fee: '', description: '' })

      toast.success(response.data.result)
      setShowModal(false)
    } catch (error) {
      toast.error(error.response?.data?.result || 'Something went wrong.')
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }

  const handleRefresh = async () => {
    setSelectedData({})

    setData(allCourses)
    setSearch('')
    setCurrentPage(1)
  }

  return (
    <div style={{ marginLeft }}>
      {/* Header */}

      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        {/* <div className="bg-secondary p-4 rounded d-flex flex-wrap justify-content-between align-items-center text-white"> */}
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">Courses</h2>
          {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
            <Button
              variant="light"
              className="fw-bold"
              onClick={() => setShowModal(true)}
            >
              <Book
                size={16}
                className="me-2 fw-bold"
                style={{ verticalAlign: 'middle' }}
              />
              <span style={{ verticalAlign: 'middle' }}>Add New Course</span>
            </Button>
          )}
        </div>
      </div>

      <Row className="g-2 align-items-center justify-content-between mt-4">
        <Col xs={12} md={3}>
          <Form.Control
            type="text"
            placeholder="Search Course Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
        <Col xs="auto">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="w-auto"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row>

      {/* Bottom Row: Total Courses and Items Per Page */}
      <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
        <p className="text-black m-0">Total Courses: {filteredData.length}</p>
        <Form.Select
          className="w-auto"
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(parseInt(e.target.value))
            setCurrentPage(1)
          }}
        >
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="30">30 per page</option>
        </Form.Select>
      </div>

      <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
        <Thead className="bg-dark text-white">
          <Tr className="bg-secondary rounded">
            <Th>Course Name</Th>
            <Th>Duration</Th>
            <Th>Fee</Th>
            <Th>Description</Th>
            {user?.user_type !== 'teacher' && <Th>Action</Th>}
          </Tr>
        </Thead>

        <Tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <Tr key={index}>
                <Td>{item.name}</Td>
                <Td>{item.duration}</Td>
                <Td>₹ {item.fee}</Td>
                <Td>{item.description}</Td>

                {/* <Button
                      variant="info"
                      onClick={() => console.log('View:', item)}
                    >
                      <Eye />
                    </Button> */}

                {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                  <Td className="text-start">
                    <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                      <Button
                        variant="warning"
                        onClick={() => {
                          setSelectedCourse(item)
                          setShowEditModal(true)
                        }}
                      >
                        <PencilSquare />
                      </Button>
                    </div>
                  </Td>
                )}
              </Tr>
            ))
          ) : (
            <Tr className="bg-light">
              <Td
                colSpan="9"
                className="text-center p-3 ms-3 fw-semibold text-muted"
              >
                No records found
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>

      {/* Pagination & Total Records */}
      <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
        <Pagination>
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Add Course Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="bg-secondary text-white">
          <Modal.Title>Add New Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            {/* Course Name */}
            <Form.Group className="mb-3">
              <Form.Label>Course Name *</Form.Label>
              <Form.Control
                type="text"
                name="course_name"
                value={newCourse.course_name}
                onChange={handleInputChange}
                placeholder="Enter Course Name"
                required
              />
            </Form.Group>
            {/* Duration */}
            <Form.Group className="mb-3">
              <Form.Label>Duration *</Form.Label>
              <Form.Control
                type="number"
                name="duration"
                value={newCourse.duration}
                onChange={handleInputChange}
                placeholder="Enter Duration"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Fee *</Form.Label>
              <Form.Control
                type="text"
                name="fee"
                value={newCourse.fee}
                onChange={handleInputChange}
                placeholder="Enter Fee"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description *</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="description"
                value={newCourse.description}
                onChange={handleInputChange}
                placeholder="Enter Course Description"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                className="text-danger"
                type="checkbox"
                id="acknowledgeCheckbox"
                label="I acknowledge and agree that this process is irreversible and cannot be undone."
                checked={isAcknowledged}
                onChange={(e) => setIsAcknowledged(e.target.checked)}
              />
            </Form.Group>

            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button
                variant="success"
                type="submit"
                disabled={!isAcknowledged}
              >
                Save Course
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <EditCourseModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        course={selectedCourse}
      />
    </div>
  )
}

export default DataTable
